/* eslint-disable */
export class Popup_Notice {
  constructor() {
    this.modalElement = $('.popup_notice_show');
    const popupGroup = this.modalElement.attr('data-group');
    this.modalCloseAt = popupGroup + 'ModalClosedAt';
    const timeout = this.modalElement.attr('data-timeout');
    const scroll = this.modalElement.attr('data-scroll');
    this.isVisible = false;
    if ( scroll ) {
      $(window).on('scroll', () => this.show_popup());
    }
    $(window).on('load', () => {
      setTimeout(() => this.show_popup(), (parseInt(timeout) * 1000));
    });
    this.modalElement.on('hidden.bs.modal', () => this.close_popup());
    this.modalElement.on('shown.bs.modal', function() {
      $(document).off('focusin.modal');
    });
  }

  show_popup() {
    const closedAt = localStorage.getItem( this.modalCloseAt.toString() );
    const now = new Date().getTime();
    const twentyFourHours = 24 * 60 * 60 * 1000;

    if (!this.isVisible && (!closedAt || now - closedAt > twentyFourHours)) {
      this.isVisible = true;
      const originalCssRight = this.modalElement.css('right');
      this.modalElement.css({
        position: 'fixed',
        right: '-100%',
      }).modal({
        backdrop: false,
        show: true,
      });

      this.modalElement.animate({
        right: originalCssRight,
      }, 1000);
    }
  }

  close_popup() {
    const now = new Date().getTime();
    if (this.modalCloseAt) {
      localStorage.setItem(this.modalCloseAt.toString(), now);
    }
  }
}
